import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8de9bad6046f12a/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/app/[locale]/tablet-bestellung/TabletPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8de9bad6046f12a/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/TabletCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabletShowcase"] */ "/tmp/8de9bad6046f12a/components/sections/TabletShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8de9bad6046f12a/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8de9bad6046f12a/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitCard"] */ "/tmp/8de9bad6046f12a/components/ui/BenefitCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PricingFactorCard"] */ "/tmp/8de9bad6046f12a/components/ui/PricingFactorCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
